import { Injectable, inject } from '@angular/core';
import { Access } from '../Utilities/enum';
import { AuthStore } from 'src/app/store/authorization/auth.store';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private readonly authStore = inject(AuthStore);
  
  /**
   * Gets the permission for a given screen and function.
   * @param screenId The screen ID to check.
   * @param functionId The function ID to check.
   * @returns Access.NoAccess | Access.Read | Access.ReadWrite
   */
  public getPermission(ScreenId: number, FunctionId: number): Access {
    return this.authStore.getPermission(ScreenId, FunctionId);
  }
}
